import React from 'react';
import styles from './securityTab.module.scss';
import ChangePassword from './components/changePassword';
import TwoFactor from './components/twoFactor';

const SecurityTab: React.FC = () => {
  return (
    <div className={styles.securityTab}>
      <ChangePassword />
      <TwoFactor />
    </div>
  );
};

export default SecurityTab;
